import { Pipe, PipeTransform } from '@angular/core';

/**
 * PrefixFilterPipe
 * Takes a string and filters out the desired prefix from that string.
 * 
 * If no string is provided and/or the prefix does not exist inside of the
 * provided string, the original string will be returned.
 * 
 * Usage: name | prefixFilter:prefix
 * Example:
 *  {{ 'OA123456' | prefixFilter:'OA' }}
 * formats to 123456
 */

@Pipe({
  name: 'prefixFilter'
})
export class PrefixFilterPipe implements PipeTransform {
  transform(name: string, prefix: string): any {
    if (!name || !prefix || !name.startsWith(prefix)) return name;

    const length = prefix.length;
    return name.substring(length);
  }
}


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/shared/pipes/prefix-filter-pipe.ts